<template
  ><section>
    <div class="page">
      <div>
        <h2>Pinning chats</h2>
        <p>
          The “Pin Chat” feature allows you to pin unlimited individual chats or
          group chats to the top of your chat list. Pinned chats will always
          stay at the top so you can quickly find them.
        </p>
        <h3>To pin a chat</h3>
        <ol>
          <li>Tap and hold the chat you wish to pin.</li>
          <li>Tap <strong>Pin to Top</strong>.</li>
        </ol>
        <h3>To unpin a chat</h3>
        <ol>
          <li>Tap and hold the pinned chat.</li>
          <li>Tap Unpin from Top.</li>
        </ol>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
